module.exports = __webpack_public_path__ + "img/customer__msg.0c67bfcf.svg";